module.exports = __webpack_public_path__ + "static/media/Feraligatr_gaussian2.32b886db.png";